import {
  BASE64_REMOVE,
  CONTACTO_ADD,
  INCREASE_SIGUIENTE,
  FORM_NAME_STEP1,
  DECREASE_STEP,
  OPEN_FINAL_MODAL,
  LOAD_CATALOG_SUCCESS,
  LOAD_DOCUMENT_SUCCESS,
  DISABLED_GENERICOS,
  CLOSE_MODAL_DIRECCION,
  CREATE_DIRECCION_MODAL,
  OPEN_MODAL_DIRECCION,
  ESTADO_AFILIACION_COMPANY,
  SAVED_CATALOG_COMPANY,
  NUMBER_FORMULARIO_FIREBASE,
  IDUSER_FORMULARIO_FIREBASE,
  MODAL_INFORMACION_FLUJOS,
  CLOSE_MODAL_FLUJOS,
  SAVE_ANEXOS,
  HANDLE_STEP,
  UPLOAD_ANEXOS,
  REMOVE_ANEXOS,
  POPUP_SEE_ANEXOS,
  CLOSED_POPUP_ADJUNTOS,
  OPEN_MODAL_NUM_PROCESS,
  CLOSE_MODAL_NUM_PROCESS,
  SAVE_DATA_TABLE_PERSONAL,
  OPEN_MODAL_CHARGED,
  CLOSE_MODAL_FINAL,
  SAVE_REFE_FILES,
  DATA_PANTALLA_INICIO,
  FORMULARIO_TYPE,
  CALL_DINAMIC_DISABLE,
  CALL_DINAMIC_DISABLE_LOTE,
  CHARGE_ANEXOS_STORAGE,
  SAVED_EMPLEADOR_TYPE,
  ACTIVE_FORM_RYA,
  EXPORT_BASE64_UNIQUE,
  LIMITE_STEP,
  FORMULARIO_OF_COMERCIAL,
  SAVED_SOLICITUDES,
  OPEN_MODAL_FINAL_FORM,
  CLOSE_MODAL_FINAL_FORM,
  SAVE_REFERENCE_BARCODE,
  INFO_USER_COMERCIAL,
  CLEAN_AUTO_COMPLETE,
  CHANGE_CORREGIMIENTO_FORM,
  OPEN_MODAL_FORMULARIO_REG,
  UNLOCK_PERSONA_NATURAL,
  INIT_CATALOG_COMPLETED,
  DEVUELTA_MODIFICACION_ACTIVE,
  SAVED_TAMANIO_FILES,
  SAVED_ID_APP,
  VALIDATE_ERRORS_FORMAT,
  UPLOAD_ANEXOS_FROM_SAGA,
  SAVE_USER_COMERCIAL,
  CHANGES_FROM_BANDEJA,
  RETURN_TO_HOME,
  OPEN_MODAL_RETURN_HOME,
  CLOSE_MODAL_RETURN_HOME,
  SAVE_PERSONAL_ADMIN,
  OPEN_MODAL_ACCEPT_PDF,
  CLOSE_MODAL_ACEPT_PDF,
  VER_MOTIVO_DEVOLUCION,
  CREATE_USUARIO_PERSONA,
  SAVE_SOLICITUDES_SIN_FIRMA,
  ERROR_GENERAL,
  UPDATE_MSG_SOLICITUD,
  MESSAGES_ALERT_PARAMETRIZADOS,
  EDITING_ENABLED_CONTACT,
  VALID_RNEC_REP_LEGAL,
  INIT_EDITAR_FROM_BANDEJA,
  SAVE_DATOS_CEDULAS_RNEC,
  GESTIONA_MODAL_TRY_CATCH,
  CHANGE_COMPONENT_ID,
  DELETE_CONTACTO_FROM_VALID_STEP4,
  DELETE_CONTACTO_EXISTS_STEP4,
  ACTIVATE_SOPORT_RNEC,
  CLOSE_DIRECCION_MODAL_SUCCESS,
  SAVE_MAPEO_RUES_SUCCESS,
} from './constants';

export const initialState = {

  errorTryCatch: false,
  base64Add: [],
  base64Start: [],
  step: 0,
  showSnackBar: false,
  steps: 5,
  message: false,
  dynamicOptions: false,
  catalogCompleted: false,
  dynamicDisable: DISABLED_GENERICOS,
  formInitialized: false,
  formfiles: [],
  formValid: false,
  openModal: false,
  contactoAdd: false,
  modalDeleteContact: { open: false },
  error: false,
  idAppForm: {
    idOportunidad: false,
    asesorAsigna: false
  },
  formDevuelto: {
    state: 0,
    modified: false,
  },
  //_______________
  openModalDireccion: false,
  nameCampoDire: false,
  estadoAfiliacionCompany: false,
  catalogSaved: {},
  idFormulario: false,
  msgParametrizados: MESSAGES_ALERT_PARAMETRIZADOS,
  cleanAutoComplete: false,
  idUser: false,
  tamanioFiles: 2000000,
  modalFlujos: {
    error: false,
    message: false,
    open: false,
  },
  modalFormReg: {
    message: false,
    open: false,
    form: false,
    messageFinal: false,
  },
  errors: {
    step1: false,
    stepPrincipal: false,
    form: false,
  },
  adjuntosStep5: [],
  nameAnexos: {},
  cambioStado: true,
  popSeeAnexos: false,
  dataRues: false,
  modalNumProcess: false,
  tableDataPersonal: [],
  openModalCharged: false,
  editEnabled: false,
  openModalFinal: false,
  userPersona: false,
  motivoDevolucion: {
    open: false,
  },
  corregimientoForm: false,
  messageConfirmation: {
    open: false,
    message: false,
  },
  popUpFormPdf: {
    open: false,
    data: "",
    type: false,
  },
  base64pdfSinFirma: false,
  refeFiles: [],
  solicitudes: false,
  dataPantallaInicio: {},
  formularioSesion: false,
  empleadorType: false,
  userInfoComercial: false,
  activeFormRyA: false,
  base64Unique: false,
  changeComponentId: {
    numberId: "number",
    numberIdCompanyGes: "number",
    numberIdStaff: "number",
  },
  formularioCustomer: {
    state: false,
  },
  personalcontactcompany: false,
  validRnecRepLegal: false,
  editInfoFromBandeja: false,
  stepLimite: false,
  modalFinalForm: false,
  referenceBarcode: "",
  pantallaModified: false,
  revisePantalla: false,
  openMondalTryCatch: false,
  solicitudesSinfirma: false,
  datosConsultaRnec: {
    representante: false,
    contacto: [],
  },
  soportRnec: false,
};

export const reducer = (state = initialState, action) => {
  let newState = { ...state };
  const { payload, type, value } = action;
  newState.showSnackBar = !newState.showSnackBar;
  newState.openModal = false;
  //newState.errorTryCatch = false;

  switch (type) {
    case INCREASE_SIGUIENTE:

      if (payload.state === true) {
        newState.step = newState.step < newState.steps ? newState.step + 1 : newState.steps;
      } else {
        newState.formValid = payload.message;
      }

      return {
        ...newState
      };

    case LIMITE_STEP:
      newState.stepLimite = payload;
      return { ...newState }

    case ERROR_GENERAL:
      newState.openModalCharged = false;
      newState.errorTryCatch = payload;
      newState.openMondalTryCatch = true;
      return { ...newState }


    case HANDLE_STEP:
      if (!newState.activeFormRya && newState.pantallaModified && value !== 2) {
        newState.revisePantalla = true;
      }

      if (!newState.activeFormRya) {
        newState.step = value;
        if (newState.empleadorType === "3" && value === 1 && !newState.revisePantalla) {
          newState.pantallaModified = true;
        } else if (value === 2 && !newState.revisePantalla) {
          newState.pantallaModified = true;
        } else {
          newState.pantallaModified = false;
        }
      }

      return { ...newState }

    case CHANGES_FROM_BANDEJA:
      newState.revisePantalla = false;
      newState.pantallaModified = false;
      return { ...newState }

    case EXPORT_BASE64_UNIQUE:
      newState.base64Unique = value;
      return { ...newState }

    case SAVE_PERSONAL_ADMIN:
      newState.personalcontactcompany = payload.data;
      return { ...newState };

    case VALID_RNEC_REP_LEGAL:
      newState.validRnecRepLegal = payload;
      return { ...newState };

    case SAVE_DATOS_CEDULAS_RNEC:
      if (payload.type)
        newState.datosConsultaRnec[payload.type] = payload.data;
      else
        newState.datosConsultaRnec = payload;
      return { ...newState };

    case INIT_EDITAR_FROM_BANDEJA:
      newState.editInfoFromBandeja = payload;
      return { ...newState };

    case FORMULARIO_OF_COMERCIAL:
      newState.userInfoComercial = {
        email: value.email,
        idUser: value.idUsuaAsesor,
        cellPhone: value.phone,
        id: value.idAsesor,
        tipoId: value.typeId,
        nameCompleted: value.name,
        rol: value.rol
      };
      newState.formularioCustomer = value;
      newState.formularioCustomer.state = true;

      return { ...newState }

    case SAVE_USER_COMERCIAL:
      newState.formularioCustomer = payload;
      newState.formularioCustomer.state = true;

      return { ...newState }

    case ACTIVE_FORM_RYA:
      newState.activeFormRyA = true;
      return { ...newState }

    case CHANGE_COMPONENT_ID:
      newState.changeComponentId[payload.field] = payload.type;
      newState.showSnackBar = !newState.showSnackBar;
      return { ...newState }

    case SAVE_SOLICITUDES_SIN_FIRMA:
      newState.solicitudesSinfirma = payload;
      return { ...newState }

    case DECREASE_STEP:
      newState.step = newState.step > 0 ? newState.step - 1 : 0;
      //newState.step = newState.step > 0 ? newState.step - 1 : 0;
      return { ...newState };

    case CONTACTO_ADD:
      newState.contactoAdd = payload.message;
      newState.error = payload.error;

      return { ...newState }

    case VALIDATE_ERRORS_FORMAT:
      if (value)
        newState.errors[value.type] = value.state;
      return { ...newState };

    case DELETE_CONTACTO_FROM_VALID_STEP4:
      newState.modalDeleteContact = payload;
      return { ...newState }

    case DELETE_CONTACTO_EXISTS_STEP4:
      newState.modalDeleteContact.open = false;
      return { ...newState }

    case LOAD_CATALOG_SUCCESS:
      newState.dynamicOptions = payload;
      return { ...newState };

    case INIT_CATALOG_COMPLETED:
      newState.catalogCompleted = true;
      return { ...newState };


    case SAVED_EMPLEADOR_TYPE:
      newState.empleadorType = payload;
      return { ...newState };

    case INFO_USER_COMERCIAL:
      newState.stepLimite = false;
      newState.userInfoComercial = value.userInfo;
      return { ...newState };

    case SAVED_CATALOG_COMPANY:
      newState.catalogSaved = payload;
      return {
        ...newState
      };

    case LOAD_DOCUMENT_SUCCESS:
      newState.dynamicOptions[payload.field] = payload.options;
      newState.showSnackBar = !newState.showSnackBar;
      return {
        ...newState
      }


    case CALL_DINAMIC_DISABLE:
      newState.dynamicDisable[payload.field] = payload.state;
      newState.showSnackBar = !newState.showSnackBar;
      return { ...newState };

    case CALL_DINAMIC_DISABLE_LOTE:
      payload.map(e => {
        newState.dynamicDisable[e.field] = e.state;
      });
      newState.showSnackBar = !newState.showSnackBar;
      return { ...newState };


    case MODAL_INFORMACION_FLUJOS:
      newState.modalFlujos = payload;
      return {
        ...newState
      }

    case SAVED_TAMANIO_FILES:
      if (payload)
        newState.tamanioFiles = payload;
      return {
        ...newState
      }

    case DEVUELTA_MODIFICACION_ACTIVE:
      newState.formDevuelto = payload;
      return {
        ...newState
      }

    case SAVED_ID_APP:
      newState.idAppForm = payload;
      return {
        ...newState
      }

    case OPEN_MODAL_FORMULARIO_REG:
      if (value && value.close)
        newState.modalFormReg = {
          message: false,
          open: false,
          form: false,
          messageFinal: false,
        }
      else
        newState.modalFormReg = payload;
      return {
        ...newState
      }

    case CLOSE_MODAL_FLUJOS:
      newState.modalFlujos = {
        error: false,
        message: false,
        open: false,
      };
      if (value && value.row) {
        newState.nameAnexos[value.row[0].value] = "";
      }
      return {
        ...newState
      }

    case BASE64_REMOVE:
      newState.base64Add = payload.data;
      return {
        ...newState
      }

    //_____________________________

    case CLOSE_MODAL_DIRECCION:

      newState.nameCampoDire = false;
      newState.openModalDireccion = false;
      newState.corregimientoForm = false;
      return { ...newState }

    case CLOSE_DIRECCION_MODAL_SUCCESS:
      newState.openModalDireccion = false;
      return { ...newState }

    case OPEN_MODAL_FINAL_FORM:
      newState.modalFinalForm = payload;
      return { ...newState }

    case CLOSE_MODAL_FINAL_FORM:
      newState.modalFinalForm = false;
      return { ...newState }

    case SAVE_REFERENCE_BARCODE:
      newState.referenceBarcode = payload;
      return { ...newState }

    case OPEN_MODAL_DIRECCION:
      newState.nameCampoDire = value.name;
      newState.openModalDireccion = true;

      return { ...newState }

    case ESTADO_AFILIACION_COMPANY:
      newState.estadoAfiliacionCompany = payload;
      newState.showSnackBar = !newState.showSnackBar;
      return { ...newState }

    case RETURN_TO_HOME:
      newState.estadoAfiliacionCompany = false;
      newState.messageConfirmation.open = false;
      newState.step = 0;
      newState.showSnackBar = !newState.showSnackBar;

      return { ...newState }

    case NUMBER_FORMULARIO_FIREBASE:
      newState.idFormulario = payload;
      return { ...newState }

    case UPDATE_MSG_SOLICITUD:

      let pos = null;
      newState.msgParametrizados.map((e, index) => {
        if (e.value === payload.id) {
          pos = index;
        }
      });

      if (pos !== null) {
        newState.msgParametrizados[pos].label = payload.text;
        newState.msgParametrizados[pos].download = payload.download;
      }
      return { ...newState }

    case CLEAN_AUTO_COMPLETE:
      newState.cleanAutoComplete = true;
      newState.showSnackBar = !newState.showSnackBar;
      return { ...newState }

    case IDUSER_FORMULARIO_FIREBASE:
      newState.idUser = payload;
      return { ...newState }

    case CHARGE_ANEXOS_STORAGE:
      newState.nameAnexos[payload.field] = payload.name;
      return { ...newState }

    case UPLOAD_ANEXOS_FROM_SAGA:

      newState.popSeeAnexos = false;
      if (payload.event) {
        newState.nameAnexos[payload.row[0].value] = payload.event.files[0].name;
        newState.formfiles.push({
          file: payload.event.files[0],
          fieldName: payload.row[0].label[0],
          fileName: payload.event.files[0].name,
          formName: payload.row[0].value
        })
      } else {
        newState.nameAnexos[payload.row[0].value] = payload.charged;
      }

      newState.showSnackBar = !newState.showSnackBar;


      return {
        ...newState
      }
    case REMOVE_ANEXOS:
      newState.nameAnexos[value.row[0].value] = "";

      if (value.event) {
        const removedFil = value.row[0].value;
        newState.formfiles = newState.formfiles.filter(item => {
          return item.fieldName === value.row[0].label[0]
            && item.formName === value.row[0].value
            && item.formName !== removedFil;
        });
      }

      newState.showSnackBar = !newState.showSnackBar;
      return {
        ...newState
      }
    case SAVE_ANEXOS:
      newState.popSeeAnexos = false;
      newState.base64Add = payload.data;
      if (payload.start) {
        newState.base64Start = [...payload.data];
      }
      newState.showSnackBar = !newState.showSnackBar;
      return { ...newState }

    case POPUP_SEE_ANEXOS:
      newState.popSeeAnexos = payload;
      return { ...newState }

    case SAVE_MAPEO_RUES_SUCCESS:
      newState.dataRues = payload;
      return { ...newState }

    case CLOSED_POPUP_ADJUNTOS:
      newState.popSeeAnexos = false;
      return { ...newState }

    case OPEN_MODAL_NUM_PROCESS:
      newState.modalNumProcess = payload;
      return { ...newState }

    case CLOSE_MODAL_NUM_PROCESS:
      newState.modalNumProcess = false;
      return { ...newState }

    case SAVE_DATA_TABLE_PERSONAL:
      newState.tableDataPersonal = payload;
      return { ...newState }

    case OPEN_MODAL_CHARGED:
      newState.openModalCharged = payload;
      return { ...newState }

    case EDITING_ENABLED_CONTACT:
      newState.showSnackBar = !newState.showSnackBar;
      newState.editEnabled = payload;
      return { ...newState }

    case CLOSE_MODAL_FINAL:
      newState.openModalFinal = false;
      return { ...newState }

    case VER_MOTIVO_DEVOLUCION:
      newState.motivoDevolucion = payload.datadevolucion;
      newState.dynamicOptions["employerDevolucion"] = payload.datadevolucion;
      newState.showSnackBar = !newState.showSnackBar;
      return { ...newState }

    case OPEN_FINAL_MODAL:
      newState.openModalFinal = true;
      newState.popUpFormPdf = {
        open: false,
        data: "",
        type: false,
      };
      return { ...newState }

    case CHANGE_CORREGIMIENTO_FORM:
      newState.corregimientoForm = payload;
      return { ...newState }

    case OPEN_MODAL_RETURN_HOME:
      newState.messageConfirmation = value;
      return { ...newState }

    case CREATE_USUARIO_PERSONA:
      newState.userPersona = payload;
      return { ...newState }

    case CLOSE_MODAL_RETURN_HOME:
      newState.messageConfirmation.open = false;
      return { ...newState }

    case OPEN_MODAL_ACCEPT_PDF:
      newState.popUpFormPdf = payload;
      newState.base64pdfSinFirma = { ...payload }
      return { ...newState }

    case CLOSE_MODAL_ACEPT_PDF:
      newState.popUpFormPdf = {
        open: false,
        data: "",
        type: false,
      };
      return { ...newState }

    case SAVE_REFE_FILES:
      newState.refeFiles = payload;
      return { ...newState }

    case GESTIONA_MODAL_TRY_CATCH:
      newState.openMondalTryCatch = false;
      return { ...newState }

    case SAVED_SOLICITUDES:
      newState.solicitudes = payload;
      return { ...newState }

    case ACTIVATE_SOPORT_RNEC:
      newState.soportRnec = payload;
      return { ...newState }

    case DATA_PANTALLA_INICIO:
      newState.dataPantallaInicio = payload;
      return { ...newState }

    case FORMULARIO_TYPE:
      newState.formularioSesion = payload;
      return { ...newState }

    default:
      return {
        ...newState
      };
  }
};
